export default {
  subtitle: "",
  path: "webhooks_wire_wainting_correcting",
  paragraph: "When FacilitaPay can't process a payment due to receiver account information errors, such as incorrect branch or account number, the API will send a 'wire_waiting_correction' notification as below:",
  request: {
    method: "POST",
    payloads: [
		{
			title: "Notification",
			content: { 
     "notification": {
        "error_code": "AC03",
        "error_description": "Creditor account number invalid or missing",
        "secret": "8958",
        "bank_account_owner_id": "person-UUID",
        "bank_account_id": "bank-account-UUID",
        "transaction_ids": [
          "transaction-UUID"
        ],
        "type": "wire_waiting_correction",
        "wire_id": "wire-UUID"
				}
			 }
		  }
		]
  },
  domainsProperties: [
    {
      name: "AC03",
      values: "Creditor account number invalid or missing (branch_number or account_number incorrect)"
    },
    {
      name: "AC14",
      values: "Creditor account type missing or invalid (account_type incorrect)"
    },
    {
      name: "CH11",
      values: "Value in Creditor Identifier is incorrect (owner_document_number incorrect)"
    },
    {
      name: "AG03",
      values: "Transaction type not supported/authorized on this account (account rejected the payment)"
    },
  ],
}



// WEBPACK FOOTER //
// ./src/components/documentation/data/WebHook/WebhooksWireWaitingCorrection.js